<template>
  <div  :class="{
    'table-cell': true,
    'table-cell-padding': !fullWidth,
  }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DataTableCell",
  props: {
    fullWidth: {type: Boolean, default: false}
  }
};
</script>

<style scoped>
.table-cell {
  width: 100%;
  height: 100%;
  min-height: 41px;
  display: flex;
  align-items: center;
}

.table-cell-padding {
  padding: 0px 0px;
}
</style>
